// @formatter:off
(function () {
  'use strict';

  var id = "activity";
  angular.module('wsLrs.cards').factory(id + ".Groups", ["$q", "ChartBuilder", 'wsColors', 'ChartUtils', function ($q, ChartBuilder, wsColors, ChartUtils) {
    return {
      getGroupCharts: function getGroupCharts(groupResults, groups, surveyMode, config) {
        if (_.isEmpty(groupResults)) {
          return [];
        }
        surveyMode = surveyMode || false;
        var top = groupResults[groups[0].id];
        var copy = _.clone(groupResults);
        //remove the top level group from the results so it won't be sorted
        delete copy[groups[0].id];
        _.sortBy(copy, function (g) {
          return g.group.name;
        });

        //then add it back on
        var values = [top].concat(_.values(copy));
        function findMax(list, field) {
          return _.max(list, function (item) {
            return item[field];
          })[field];
        }
        var max = _.max([findMax(values, "completed"), findMax(values, "succeeded"), findMax(values, "incompleted"), findMax(values, "failed")]);
        var min = max * -1;
        var chartArr = _.map(values, function (value) {
          value.failed = value.failed <= 0 ? value.failed : value.failed * -1;
          value.incompleted = value.incompleted <= 0 ? value.incompleted : value.incompleted * -1;
          var rtn = {
            name: value.group.name,
            id: value.group.id,
            group: value.group,
            selected: value.selected,
            chart: new ChartBuilder().type("bar")
            //.margin([0, 0, 0, 0])
            .spacing([0, 0, 0, 0]).xAxis().labels().enabled(false).build().build().yAxis().title().text(null).build().max(max).min(min).labels().enabled(false).build().build().title().text(null).build().tooltip().backgroundColor('transparent').borderWidth(0).followPointer(true).shadow(false).shared(true).useHTML(true).valueDecimals(2).formatter(function () {
              var tool = '<div class="watershed-tooltip" ><table><thead><tr><th>' + '</th></tr></thead>';
              var t = this.points[0];
              this.points[0] = this.points[1];
              this.points[1] = t;
              _.each(this.points, function (p, pi) {
                var display = p.series.name.toLowerCase();
                if (Math.abs(p.y) === 1) {
                  display = display.replace(display === "successes" ? /es$/ : /s$/, '');
                }
                if (pi % 2 === 0) {
                  tool += '<tr>';
                }
                tool += '<td style="color:' + p.series.color + '">' + Math.abs(p.y) + ' ' + display + '</td>';
                if (pi % 2 === 1) {
                  tool += '</tr>';
                }
              });
              tool += '</table></div>';
              return tool;
            }).build().series().name("Incompletes").data([value], "incompleted").stack("one").color(wsColors.wsGrayLight).build().series().name("Completions").data([value], "completed").stack("one").color(ChartUtils.getSeriesColor(config, 0, wsColors.wsBlue)).build().legend().enabled(false).build().plotOptions({
              bar: {
                stacking: 'normal',
                pointWidth: 20
              }
            }).title().text(null).build()
          };
          if (!surveyMode) {
            rtn.chart.series().name("Successes").data([value], "succeeded").stack("two").color(ChartUtils.getSeriesColor(config, 1, wsColors.wsGreen)).build().series().name("Failures").data([value], "failed").stack("two").color(ChartUtils.getSeriesColor(config, 2, wsColors.wsRed)).build();
          }
          return rtn;
        });
        angular.forEach(chartArr, function (chartObj, count) {
          var chart = chartObj.chart;
          if (count === chartArr.length - 1) {
            chartObj.chart = chart.spacing([0, 0, 5, 0]).yAxis().title().text(null).build().gridLineColor("#eee").lineColor("#eee").max(max).min(min).labels().enabled(true).formatter(function () {
              return Math.abs(this.value);
            }).build().build();
          }
          chartArr[count].chart = chartObj.chart.result();

          //mark this group chart as empty if every point in every series is null or 0
          chartObj.empty = _.every(chartObj.chart.series, function (s) {
            return _.isEmpty(s.data) || _.every(s.data, function (d) {
              return !d;
            });
          });
        });
        return chartArr;
      }
    };
  }]).controller(id + ".GroupTable", ["$scope", "$controller", "$q", "CardRegistry", function ($scope, $controller, $q, CardRegistry) {
    var surveyMode = CardRegistry.get($scope.cardId).configuration.surveyMode;
    $scope.sortControls = [{
      "title": "Group",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Total Completions",
      "options": {
        "Ascending": "completed",
        "Descending": "-completed"
      }
    }, {
      "title": "Total Successes",
      "options": {
        "Ascending": "succeeded",
        "Descending": "-succeeded"
      }
    }, {
      "title": "Avg Score",
      "options": {
        "Ascending": "averageScore",
        "Descending": "-averageScore"
      }
    }, {
      "title": "Avg Time to Complete",
      "options": {
        "Ascending": "averageDurationCentiseconds",
        "Descending": "-averageDurationCentiseconds"
      }
    }];
    $scope.totalControls = $scope.sortControls;
    $scope.percentageControls = [{
      "title": "Group",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Completion Percentage",
      "options": {
        "Ascending": "completedPercent",
        "Descending": "-completedPercent"
      }
    }, {
      "title": "Success Percentage",
      "options": {
        "Ascending": "succeededPercent",
        "Descending": "-succeededPercent"
      }
    }, {
      "title": "Avg Score",
      "options": {
        "Ascending": "averageScore",
        "Descending": "-averageScore"
      }
    }, {
      "title": "Avg Time to Complete",
      "options": {
        "Ascending": "averageDurationCentiseconds",
        "Descending": "-averageDurationCentiseconds"
      }
    }];
    if (surveyMode === true) {
      // Remove the success and score headers from both tabs.
      $scope.sortControls.splice(2, 2);
      $scope.percentageControls.splice(2, 2);
    }
    $scope.updateSelection = function (newSelection) {
      if (newSelection === "Percentage") {
        $scope.sortControls = $scope.percentageControls;
      } else if (newSelection === "Total") {
        $scope.sortControls = $scope.totalControls;
      }
    };
    $scope.defaultSortBy = "name";

    /*jshint camelcase: false */
    $scope.fetchData = function (params) {
      var deferred = $q.defer();
      var vals = _.clone($scope.section.data);
      var selected = _.find(vals, function (val) {
        return val.selected;
      });
      if (selected) {
        delete vals[selected.id];
      }
      vals = _.values(vals);
      if (params.order_by) {
        var reverse = false;
        var orderBy = params.order_by;
        if (orderBy.lastIndexOf("-", 0) === 0) {
          orderBy = orderBy.substring(1, orderBy.length);
          reverse = true;
        }
        if (orderBy === "name") {
          orderBy = function orderBy(val) {
            return val.name.toLowerCase();
          };
        }
        vals = _.sortBy(vals, orderBy);
        if (reverse) {
          vals.reverse();
        }
      }
      if (selected) {
        vals = [selected].concat(vals);
      }
      var numResults = _.size(vals);
      deferred.resolve({
        "results": vals,
        "count": numResults
      });
      return deferred.promise;
    };
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    /*jshint camelcase: true */
  }]);
  // formatter:on
})();
